<template>
  <fragment>
    <div class="flex flex-wrap mb-6 text-center">
      <fragment v-for="(app, appType) in apps" :key="appType.split('+')[0]">
        <fragment v-if="app.length > 0">
          <fragment v-for="(subApp, index) in app" :key="index">
            <fragment>
              <div
                class="md:w-1/2 lg:w-1/3 w-full my-4"
                ref="ecosystemElementRef"
              >
                <ecosystem-app
                  :customClass="seperatedApps ? 'mx-4' : ''"
                  :type="appType.split('+')[0]"
                  :application="subApp"
                ></ecosystem-app>
              </div>
            </fragment>
            <fragment>
              <div
                v-if="
                  app.user_id != currentUser.id &&
                  !verifyMemberExistAppType(appType.split('+')[0])
                "
                class="md:w-1/2 lg:w-1/3 w-full my-4"
              >
                <ecosystem-app
                  :customClass="seperatedApps ? 'mx-4' : ''"
                  :type="appType.split('+')[0]"
                  :dependent="verifyDependency(appType.split('+')[0])"
                ></ecosystem-app>
              </div>
            </fragment>
          </fragment>
        </fragment>

        <fragment v-else>
          <div class="md:w-1/2 lg:w-1/3 w-full my-4">
            <ecosystem-app
              :customClass="seperatedApps ? 'mx-4' : ''"
              :type="appType.split('+')[0]"
              :dependent="verifyDependency(appType.split('+')[0])"
            ></ecosystem-app>
          </div>
        </fragment>
      </fragment>
      <div
        v-if="showCreateMoreCard"
        class="btn-add-app md:w-1/2 lg:w-1/3 w-full my-4"
        :style="{ height: customHeight + 'px' }"
      >
        <div
          class="
            box-info
            relative
            p-4
            rounded
            shadow-lg
            font-bold
            text-blue
            hover:opacity-75
            h-full
            text-2sm
            flex
            items-center
            justify-center
          "
          :class="seperatedApps ? 'mx-4' : ''"
        >
          <div class="text-sm">
            <div class="mb-4 text-center">
              <button
                @click="showCreateAction(false, apps)"
                v-scroll-to="{
                  el: element,
                }"
                class="relative button bg-red hover:bg-red text-white font-bold"
              ></button>
            </div>
            <span class="inline-block text-center">{{
              $t("candidat.add_new_app")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div :id="element.substring(1)" class="flex flex-wrap mb-6 text-center">
      <fragment v-for="(app, index) in newApps" :key="index">
        <div class="md:w-1/2 lg:w-1/3 w-full my-4">
          <ecosystem-app
            :type="app"
            :dependent="verifyDependency(app)"
          ></ecosystem-app>
        </div>
      </fragment>
    </div>
  </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import EcosystemApplication from "./Application";
import { mapGetters } from "vuex";
export default {
  name: "grid",
  components: {
    "ecosystem-app": EcosystemApplication,
    fragment: Fragment,
  },
  props: {
    data: {
      required: true,
      type: Object,
      default: null,
    },
    seperatedApps: {
      required: false,
      type: Boolean,
      default: false,
    },
    types: {
      required: true,
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      showCreateMoreCard: false,
      newApps: [],
      apps: {},
      // Generate element to scroll to according to the type of application
      element: "#apply-new-app" + this.types[0],
    };
  },
  mounted() {
    this.showCreateAction(true, this.apps);
  },
  created() {
    let self = this;
    if (
      this.currentUser.role == "sso" &&
      this.data["Deal"].length > 0 &&
      this.data["Certif"].length > 0 &&
      this.data["Sail"].length > 0
    ) {
      Object.entries(this.data["Deal"]).forEach(([dealKey, dealApp]) => {
        if (dealApp.hasOwnProperty("parent") && dealApp.parent) {
          Object.entries(this.data["Certif"]).forEach(
            ([certifKey, certifApp]) => {
              if (certifApp.id && certifApp.id == dealApp.parent) {
                self.apps["Certif"] = [certifApp];
                self.apps["Deal"] = [dealApp];
              } else {
                self.apps["Certif+" + certifKey] = [certifApp];
              }
            }
          );
        }
      });

      Object.entries(this.data["Sail"]).forEach(([sailKey, sailApp]) => {
        if (sailApp.hasOwnProperty("parent") && sailApp.parent) {
          Object.entries(this.data["Certif"]).forEach(
            ([certifKey, certifApp]) => {
              if (certifApp.id && certifApp.id == sailApp.parent) {
                self.apps["Certif"] = [certifApp];
                self.apps["Sail"] = [sailApp];

              } else {
                self.apps["Certif+" + certifKey] = [certifApp];
              }
            }
          );
        }
      });
    } else {
      Object.entries(this.data).forEach(([key, apps]) => {
        if (self.types.includes(key)) {
          self.apps[key] = apps;
        }
      });
    }
  },
  methods: {
    // Show create new applications based on old refused applications types
    showCreateAction(showCreateMore = false, applications) {
      // Prevent adding infinite new application cards
      if (
        document.getElementById("apply-new-app" + this.types[0]).childNodes
          .length == 0
      ) {
        var self = this;
        var filteredApplications = {};
        /**
         * Check only on apps of current logged in user
         * by doing this, you don't have to check if it's lead or memeber apps
         */
        Object.entries(applications).forEach(([key, apps]) => {
          filteredApplications[key] = apps.filter( app =>  this.currentUser.id == app.user_id );
        });

        Object.entries(filteredApplications).forEach(([key, apps]) => {
          if (apps.length > 0) {
            let lastApplication = apps[apps.length - 1];
            if (
              (apps.length > 0 &&
                (["3", "6", "8", "10"].includes(lastApplication.status) ||
                  ["Air", "Air2", "D4D", "MAIR", "VAIR"].includes(lastApplication.type)) &&
                lastApplication.result &&
                lastApplication.result.status == "2")
            ) {
              if (
                key == "Deal" &&
                lastApplication.type == "Deal" &&
                this.data["Certif"][this.data["Certif"].length - 1].status !=
                  "3"
              ) {
                self.apps["Deal+1"] = [];
                self.showCreateMoreCard = true;
              } else {
                showCreateMore
                  ? (self.showCreateMoreCard = true)
                  : self.newApps.push(lastApplication.type);
              }
              if (
                key == "Sail" &&
                lastApplication.type == "Sail" &&
                this.data["Certif"][this.data["Certif"].length - 1].status !=
                  "3"
              ) {
                self.apps["Sail+1"] = [];
                self.showCreateMoreCard = true;
              } else {
                showCreateMore
                  ? (self.showCreateMoreCard = true)
                  : self.newApps.push(lastApplication.type);
              }
            }
          }
        });
      }
    },
    // Check if current application is dependant from other applications
    verifyDependency(type) {
      var verif = true;
      if (type == "Deal" || type == "Sail") {
        Object.entries(this.data).forEach(([key, apps]) => {
          if (
            (key == "Certif" &&
              apps.length > 0 &&
              ["0", "3", "6", "8", "10", "11"].includes(
                apps[apps.length - 1].status
              )) ||
            (key == "Certif" && !apps.length)
          ) {
            verif = false;
          }
          if (key == "Certif" && apps.length > 0) {
            if(apps[apps.length - 1].user_id != this.currentUser.id) {
              verif = false;
            }
          }
        });
      }

      return verif;
    },
    verifyMemberExistAppType(type) {
      let counter = 0;
      // Check if member user have an application with this type
      Object.entries(this.data[type]).forEach(([key, app]) => {
        if (app.user_id == this.currentUser.id) {
          counter++;
        }
      });

      if (counter == 0) {
        return false;
      }

      return true;
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
    customHeight() {
      let ecosystemBloc = this.$refs.ecosystemElementRef;
      if (Array.isArray(ecosystemBloc)) {
        ecosystemBloc = ecosystemBloc[0];
      }
      return ecosystemBloc.clientHeight;
    },
  },
};
</script>

<style></style>
